import { render, staticRenderFns } from "./ContractCard.vue?vue&type=template&id=be152418"
import script from "./ContractCard.vue?vue&type=script&lang=ts"
export * from "./ContractCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports